import React from "react";
import styles from "./AppIconHome.scss";
import { useAppState } from "src/app/state/StateProvider";
import { useAppText } from "src/commun/composants/AppText";
import { useNavigate } from "react-router-dom";
import { goToUrl } from "src/app/menu/menuutil";
// @ts-ignore
import imgLogo from "src/img/logo_FER.svg";

const AppIconHome = () => {
  const [state] = useAppState();
  const { tString } = useAppText();
  const navigate = useNavigate();

  return (
    <img
      className={styles.iconFERGE}
      title={tString("action.redirect.page.accueil")}
      alt={tString("action.redirect.page.accueil")}
      // on ne recupère pas le logo provenant de la conf car il faut etre connecté pour avoir le menu, or pour les formulaires de finalisation&rattachement l'utilisateur n'est pas connecté
      //src={(state.menu?.imageBaseURl || "") + "logo_FER.svg"}
      src={imgLogo}
      onClick={() => goToUrl((state.menu?.accueilMepUrl || ""), false, navigate)}
      height="40px"
    />
  );
};

export default AppIconHome;
